export default __webpack_public_path__ + "static/media/define4.a3da6745.png";